function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React, { forwardRef, useRef } from 'react';
import PropTypes from 'prop-types';
import NumberSpinner from '../NumberSpinner/NumberSpinner';
import { TextInput } from '../TextInput';
import useMergeRefs from '@dtsl/react/dist/components/Utils/customHooks/useMergeRefs';

// eslint-disable-next-line react/display-name
const NumberInput = /*#__PURE__*/forwardRef((props, ref) => {
  const {
    min,
    max,
    ...restProps
  } = props;
  const numberInputRef = useRef();
  const mergedRef = useMergeRefs(numberInputRef, ref);
  const numberActions = [() => /*#__PURE__*/React.createElement(NumberSpinner, {
    handleValueChange: handleValueChange
  })];
  const setNumberInputValue = (numValue, shouldIncrement) => {
    const dispatchChangeEvent = () => {
      const ev = new Event('change', {
        bubbles: true
      });
      numberInputRef.current?.dispatchEvent(ev);
      numberInputRef.current?.focus();
    };
    const handleMinMax = (min, max) => {
      if (numValue <= min && shouldIncrement) {
        numberInputRef.current.stepUp();
      } else if (numValue >= max && !shouldIncrement) {
        numberInputRef.current.stepDown();
      } else if (numValue > min && numValue < max) {
        shouldIncrement ? numberInputRef.current.stepUp() : numberInputRef.current.stepDown();
      }
    };
    if (min && max) {
      handleMinMax(min, max);
    } else {
      shouldIncrement ? numberInputRef.current.stepUp() : numberInputRef.current.stepDown();
    }
    dispatchChangeEvent();
  };
  const handleValueChange = (e, shouldIncrement) => {
    e.preventDefault();
    if (numberInputRef?.current) {
      const value = numberInputRef.current.value ?? 0;
      const numValue = Number(value);
      setNumberInputValue(numValue, shouldIncrement);
    }
  };
  return /*#__PURE__*/React.createElement(TextInput, _extends({}, restProps, {
    min: min,
    max: max,
    ref: mergedRef,
    actions: numberActions
  }));
});
NumberInput.propTypes = {
  min: PropTypes.number,
  max: PropTypes.number
};
export default NumberInput;